<div class="bmc-ai-jobs-wrapper">  
    <ai-jobs-list [userJobs]="userJobs" [currentUserJob]="currentUserJob" class="bmc-ai-jobs-wrapper__left" (onSetUserJob)="setCurrentJob($event)"></ai-jobs-list> 
    <ai-jobs-description *ngIf="userJobs?.length" class="bmc-ai-jobs-wrapper__right" [currentUserJob]="currentUserJob" (cancel)="currentUserJob = null" (resetEmit)="reset()" (userJobUpdate)="setUserJob($event)"></ai-jobs-description>
    <div class="bmc-ai-jobs-wrapper__no-items" *ngIf="!userJobs?.length">
        <h3>{{'WAITS.NO_WAITS_TITLE' | translate}}</h3>
        <h4>{{'WAITS.NO_WAITS_SUBTITLE' | translate}}</h4>
      </div>
</div>
